"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _toConsumableArray2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _staff = require("@/api/staff");
var _role = require("@/types/role");
var _StaffItem = _interopRequireDefault(require("./StaffItem.vue"));
var _building = require("@/api/building.api");
var BuildingAddStaffModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BuildingAddStaffModal, _Vue);
  var _super = (0, _createSuper2.default)(BuildingAddStaffModal);
  function BuildingAddStaffModal() {
    var _this;
    (0, _classCallCheck2.default)(this, BuildingAddStaffModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "search", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "staffs", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectedStaffs", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingSubmit", false);
    return _this;
  }
  (0, _createClass2.default)(BuildingAddStaffModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }, {
    key: "handleClickStaff",
    value: function handleClickStaff(staff) {
      debugger;
      var index = this.selectedStaffs.findIndex(function (e) {
        return e.id == staff.id;
      });
      if (index == -1) {
        this.selectedStaffs.push(staff);
      } else {
        this.selectedStaffs.splice(index, 1);
      }
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handleChoose",
    value: function () {
      var _handleChoose = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var staffIds;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                debugger;
                this.loadingSubmit = true;
                _context.prev = 2;
                staffIds = this.selectedStaffs.map(function (e) {
                  return e.id;
                });
                _context.next = 6;
                return _building.buildingApi.addStaff(this.buildingId, {
                  staffIds: staffIds
                });
              case 6:
                this.visible = false;
                this.onSubmitOk();
                this.$notify({
                  title: "Thông báo",
                  message: "Chỉnh sửa danh sách nhân viên thành công",
                  type: "success"
                });
              case 9:
                _context.prev = 9;
                this.loadingSubmit = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2,, 9, 12]]);
      }));
      function handleChoose() {
        return _handleChoose.apply(this, arguments);
      }
      return handleChoose;
    }()
  }, {
    key: "fetchStaffs",
    value: function () {
      var _fetchStaffs = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var roleNames, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                roleNames = [_role.RoleName.Manager, _role.RoleName.Advisor, _role.RoleName.Sale, _role.RoleName.Service, _role.RoleName.Account, _role.RoleName.Supervisor, _role.RoleName];
                this.loading = true;
                _context2.next = 4;
                return _staff.staffApi.findAll({
                  roleNames: roleNames,
                  search: this.search,
                  page: 1,
                  limit: 20
                });
              case 4:
                res = _context2.sent;
                this.loading = false;
                this.staffs = res.data.staffs;
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function fetchStaffs() {
        return _fetchStaffs.apply(this, arguments);
      }
      return fetchStaffs;
    }()
  }, {
    key: "handleOpen",
    value: function handleOpen(selectedStaffs) {
      this.selectedStaffs = (0, _toConsumableArray2.default)(selectedStaffs);
      this.fetchStaffs();
      this.visible = true;
    }
  }]);
  return BuildingAddStaffModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], BuildingAddStaffModal.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], BuildingAddStaffModal.prototype, "onSubmitOk", null);
BuildingAddStaffModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    StaffItem: _StaffItem.default
  }
})], BuildingAddStaffModal);
var _default = BuildingAddStaffModal;
exports.default = _default;